import { create } from 'zustand';

type ObjectEditLayoutState = {
  inlineFindingEditId: string | null;
  setInlineFindingEditId: (findingId: string | null) => void;
};

export const useObjectEditLayoutStore = create<ObjectEditLayoutState>(
  (set) => ({
    inlineFindingEditId: null,
    setInlineFindingEditId: (findingId) =>
      set({ inlineFindingEditId: findingId }),
  }),
);
